import { createContext, useContext } from "react";

/**
 * Marca el subarbol que monta `renderRouteInPortal` para exportar una ruta a PDF o
 * a Excel.
 *
 * El contenedor del portal esta oculto (fuera de viewport), pero los overlays que
 * escapan a `document.body` con `createPortal` —el `LoadingScreen` de la vista que
 * se esta exportando— se salen de ese contenedor y terminan encima de la app real.
 * Los componentes que hacen eso consultan esta bandera para no renderizarse
 * durante una exportacion.
 *
 * Vive en su propio modulo (y no en `routePortal.tsx`) porque ese importa
 * `AppRouter`: un componente de hoja como `LoadingScreen` no puede arrastrar el
 * arbol de rutas completo solo para leer la bandera.
 */
const ExportPortalContext = createContext<boolean>(false);

export const ExportPortalProvider = ExportPortalContext.Provider;

export const useIsExportPortal = (): boolean => useContext(ExportPortalContext);
